module.exports = __webpack_public_path__ + "static/media/CGC logo.b1e7366f.png";